export function MYOBSupportCtrl ($http, $uibModal, $scope, $window, confirm, messages, workshopAPI, MYOBSupport) {

  $scope.MYOBSupport = new MYOBSupport();
}